import { useMemo } from 'react';

import { useGetWorkBetterAdminsQuery } from '../api';

export const useGetWorkbetterAdminsList = () => {
  const { data, refetch } = useGetWorkBetterAdminsQuery();

  const getAdminsList = useMemo(() => data, [data]);

  return { getAdminsList, refetchAdminsList: refetch };
};
